import {
    getSweetShopArticleCategories,
    GetSweetShopArticleCategoriesApiResponseSchema,
} from './get-sweet-shop-article-categories';
import {
    getSweetShopService,
    GetSweetShopServiceActionResponseMapper,
} from './get-sweet-shop-service';
import {
    getCakeToOrderCards,
    GetCakeToOrderCardsApiResponseSchema,
} from './get-cake-to-order-cards';

export {
    GetSweetShopArticleCategoriesApiResponseSchema,
    GetSweetShopServiceActionResponseMapper,
    GetCakeToOrderCardsApiResponseSchema,
};

export const SweetShopPageActions = {
    getSweetShopArticleCategories,
    getSweetShopService,
    getCakeToOrderCards,
};
